module.exports = __webpack_public_path__ + "img/logo-store.6b5eb58.svg";